/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/** One entry of a message definition record: which field, how wide, what type. */
public class FieldDefinition(
    public val num: UByte,
    public val size: Int,
    public val typeId: UByte,
) {
    public constructor(num: UByte, size: Int, baseType: BaseType) : this(num, size, baseType.id)

    internal constructor(field: FieldBase) : this(field.fieldNum, field.size, field.declaredTypeId ?: field.baseType.id)

    /**
     * The base type this definition names.
     *
     * Null when a producer wrote a type byte outside the 17 the protocol
     * defines, which happens in the wild; the decoder then skips the field.
     */
    public val baseType: BaseType? get() = BaseType.fromId(typeId)

    /** Number of values packed into this field. */
    public val count: Int get() = baseType?.let { if (it.size == 0) 0 else size / it.size } ?: 0

    public fun write(writer: ByteWriter) {
        writer.writeByte(num)
        writer.writeByte(size.toUByte())
        writer.writeByte(typeId)
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is FieldDefinition) return false
        return num == other.num && size == other.size && typeId == other.typeId
    }

    override fun hashCode(): Int = (num.toInt() * 31 + size) * 31 + typeId.toInt()

    override fun toString(): String = "FieldDefinition(num=$num, size=$size, type=${baseType ?: typeId})"

    public companion object {
        public fun read(reader: ByteReader): FieldDefinition =
            FieldDefinition(reader.readByte(), reader.readByte().toInt(), reader.readByte())
    }
}

/**
 * A field declared at runtime by a `developer_data_id` / `field_description`
 * pair rather than by the profile.
 *
 * The definition record only carries the indices; resolving them to the
 * declaring messages is the decoder's job.
 */
public class DeveloperFieldDefinition(
    public val num: UByte,
    public val size: Int,
    public val developerDataIndex: UByte,
) {
    public fun write(writer: ByteWriter) {
        writer.writeByte(num)
        writer.writeByte(size.toUByte())
        writer.writeByte(developerDataIndex)
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is DeveloperFieldDefinition) return false
        return num == other.num && size == other.size && developerDataIndex == other.developerDataIndex
    }

    override fun hashCode(): Int = (num.toInt() * 31 + size) * 31 + developerDataIndex.toInt()

    public companion object {
        public fun read(reader: ByteReader): DeveloperFieldDefinition =
            DeveloperFieldDefinition(reader.readByte(), reader.readByte().toInt(), reader.readByte())
    }
}
